import { type Address, isAddressEqual } from 'viem'

import { ActionFlowError } from '../types.action-flow'

// Guards against signer/owner drift (MORP3-16): a flow is built for a specific
// account (baked into onBehalf/maker calldata), but the wallet can change
// between review and confirmation. Throw a user-facing error rather than sign
// for the wrong account.
export function assertExpectedAccount({
  expectedAccountAddress,
  signerAddress
}: {
  expectedAccountAddress: Address | undefined
  signerAddress: Address
}) {
  if (expectedAccountAddress && !isAddressEqual(expectedAccountAddress, signerAddress)) {
    throw new ActionFlowError('Connected wallet changed. Reconnect it or start over.')
  }
}
